export type CameraMode = "cosmos" | "singularity" | "architecture" | "inspection" | "orbital-follow";

export type CameraFrame = {
  mode: CameraMode;
  radius: number;
};

export class CameraFramingPolicy {
  distance(frame: CameraFrame) {
    if (frame.mode === "singularity") return Math.max(12.6, Math.min(18.2, frame.radius * 2.2));
    if (frame.mode === "architecture") return Math.max(13.8, Math.min(24, frame.radius * 4.4));
    if (frame.mode === "inspection") return Math.max(10.8, Math.min(17.5, frame.radius * 5.2));
    if (frame.mode === "orbital-follow") return Math.max(8.8, Math.min(13.6, frame.radius * 5.8));
    return 44;
  }

  flybyOvershoot(mode: CameraMode) {
    if (mode === "singularity") return 0.26;
    if (mode === "architecture") return 0.18;
    if (mode === "inspection") return 0.13;
    if (mode === "orbital-follow") return 0.08;
    return 0;
  }
}
